import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { IReducer } from '../../redux/configureStore';
import {
  getPartnerProfile,
  getProducts,
  getProfileAuth,
  getProfileUser,
} from '../../redux/fetchActions/productsPage/productsPage';
import { Logout } from '../../redux/fetchActions/tokens';
import { PATHS } from '../../routes';
import SideMenu from '../../shared/components/SideMenu';
import Frame from './components/Frame';
import { ReturnProductIfAvailable } from './functions';

function ProductsPage() {
  const isLoggedContext = useSelector(
    (reducer: IReducer) => reducer.loginAuth.isAuthenticated
  );
  const productsContext = useSelector((reducer: IReducer) => reducer.products);
  const profileContext = useSelector(
    (reducer: IReducer) => reducer.userProfile
  );
  const profileAuthContext = useSelector(
    (reducer: IReducer) => reducer.profileAuth
  );
  const loginToken = localStorage.getItem('loginToken');
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isLoggedContext) {
      dispatch(Logout());
      history.push(PATHS.login);
    }
  }, [isLoggedContext]);

  useEffect(() => {
    if (loginToken !== null) {
      dispatch(getProducts());
      dispatch(getProfileUser());
    } else {
      history.push(PATHS.login);
    }
  }, [loginToken]);

  useEffect(() => {
    if (profileContext !== undefined) {
      dispatch(getProfileAuth(profileContext.id));
      if (profileContext.partnerId !== undefined) {
        dispatch(getPartnerProfile(profileContext.partnerId));
      }
    }
  }, [profileContext]);

  return (
    <Frame.Base>
      <SideMenu />
      <Frame.Products>
        <ReturnProductIfAvailable
          productsContext={productsContext}
          profileAuthContext={profileAuthContext}
          history={history}
        />
      </Frame.Products>
    </Frame.Base>
  );
}

export default ProductsPage;
